import { NgOptimizedImage } from '@angular/common'
import { Component } from '@angular/core'
import { environment } from '../../../../environments/environment'
import { RouterLink } from '@angular/router'

@Component({
	selector: 'app-logo',
	imports: [NgOptimizedImage, RouterLink],
	templateUrl: './logo.html',
	styleUrl: './logo.css',
})
export class Logo {
	symbol = `${environment.webStorageUrl}/custom-content-assets/RadiusAuto/logo/light-symbol.svg`
}
